import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequestExactAlarmModalPage } from './request-exact-alarm.modal.page';

const routes: Routes = [
  {
    path: '',
    component: RequestExactAlarmModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequestExactAlarmPageRoutingModule {}
